<template>
	<BaseWebshopCouponForm v-slot="{onSubmit, onRemove, couponCode, message, loading, activeCoupon, handleInput}" :multiple-coupons="true" @submit="submitCoupon">
		<div class="coupons" :class="{'loading': loading}">
			<form @submit.prevent="onSubmit()">
				<div class="title"><BaseCmsLabel code="coupon_enter_code" /></div>
				<div class="coupon-form">
					<input class="base-coupons-input" :placeholder="labels.get('coupon_code')" type="text" :value="couponCode" name="coupon" @keyup="handleInput" />
					<button :disabled="loading || !couponCode" type="submit">
						<UiLoader mode="dots" v-if="loading" />
						<BaseCmsLabel code="coupon_add" v-else />
					</button>
				</div>
				<BaseCmsLabel v-if="message" class="status" tag="div" :code="message" />

				<!--
				<div class="coupons-list">
					<div class="coupons-list-title"><BaseCmsLabel code="coupon_available" /></div>
					<table cellspacing="0" cellpadding="0" class="coupons-list-items">
						<thead>
							<th>Vrijednost</th>
							<th>Promo kod</th>
							<th></th>
						</thead>
						<tbody>
							<tr>
								<td class="coupon-item-value"><span>-30%</span></td>
								<td class="coupon-item-title">test</td>
								<td class="coupon-item-btn"><span><BaseCmsLabel code="coupon_remove" /></span></td>
							</tr>
							<tr>
								<td class="coupon-item-value"><span>-30%</span></td>
								<td class="coupon-item-title">test</td>
								<td class="coupon-item-btn"><span><BaseCmsLabel code="coupon_remove" /></span></td>
							</tr>
						</tbody>
					</table>
				</div>
				-->
				
				<div v-if="activeCoupon && activeCoupon.meta_data?.length" class="coupons-list loading">
					<table cellspacing="0" cellpadding="0" class="coupons-list-items">
						<thead>
							<tr>
								<th><BaseCmsLabel code="coupon_code" /></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in activeCoupon.meta_data" :key="item.id">
								<td class="coupon-item-title" :class="{'invalid': !item.applied}">
									<span>"{{item.code}}" </span>
									<template v-if="item.applied"><BaseCmsLabel code="coupon_valid" /></template>
									<template v-else><BaseCmsLabel code="coupon_not_valid" /></template>
								</td>
								<td class="coupon-item-btn">
									<span @click="onRemove({code: item.code})"><BaseCmsLabel code="coupon_remove" /></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			
			</form>
		</div>
	</BaseWebshopCouponForm>
</template>

<script setup>
	const labels = useLabels();
	function submitCoupon(data) {
		if(data) data.clearInput();
	}
</script>

<style lang="less" scoped>
	.coupons{
		padding: 20px 0 20px; position: relative;
		&.loading:before{.pseudo(auto,auto); top: 45px; right: 0; bottom: 0; left: 0; background: rgba(255,255,255,0.5); z-index: 10;}
	}
	.title{font-size: clamp(14px, 2vw, 15px); font-weight: bold; padding: 0 0 10px;}
	.coupon-form{display: flex; height: 48px;}
	input{border: 1px solid var(--gray5); border-radius: 8px 0 0 8px; border-right: 0; flex-grow: 1; height: 100%; font-size: clamp(14px, 2vw, 16px);}
	button{border-radius: 0 8px 8px 0; flex: 0 0 130px; height: 100%; padding: 0; display: flex; align-items: center; justify-content: center;}
	.status{font-size: 12px; padding: 6px 0 0 12px;}
	
	.coupons-list-items{
		width: 100%;
		thead{text-align: left;}
		th{font-weight: normal; color: var(--gray5); padding-bottom: 5px;}
		td{padding: 5px 0;}
	}
	.coupons-list{padding: 20px 0 0; font-size: 12px;}
	.coupons-list-title{padding-bottom: 20px; font-size: clamp(14px, 2vw, 15px);}
	.coupon-item-value{
		padding: 0 0 15px; font-size: 12px;
		span{display: inline-flex; background: var(--green); border-radius: 3px; color: #fff; padding: 2px 5px;}
	}
	.coupon-item-btn{
		margin-left: auto; text-align: right; color: var(--blueDark);
		span{text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: 2px; cursor: pointer;}
	}
	.invalid{color: var(--gray5);}
</style>
